import script from "./Hint.vue?vue&type=script&lang=ts&setup=true"
export * from "./Hint.vue?vue&type=script&lang=ts&setup=true"

import "./Hint.vue?vue&type=style&index=0&id=94990494&lang=scss"

const __exports__ = script;

export default __exports__